import i18n from '@/i18n'; /*
 * @Author: TigerLord
 * @Date: 2022-09-06 15:30:55
 * @LastEditTime: 2022-09-26 14:00:15
 * @LastEditors: your name
 * @Description: 功能说明：——
 * @FilePath: /ytzx-console/src/pages/statis/PersonBill/index.ts
 */
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('PersonBill-index-1992f2b86c05c884e-1'),
    routerUrl: '/PersonBill',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./PersonBill')),
    children: [
      // {
      //   needLogin: true,
      //   resourceName: "新增WanjinyouBill",
      //   routerUrl: "/PersonBillForm",
      //   resourceIcon: "",
      //   type: "2",
      //   buttons: [],
      //   component: loadable(() => import("./PersonBillForm")),
      // },
      //$MORE$
    ],
  },
  {
    needLogin: true,
    resourceName: i18n.t('PersonBill-index-1992f2b86c05c884e-2'),
    routerUrl: '/PersonAddBillApplyList',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./PersonAddBillApplyList')),
    children: [
      // {
      //   needLogin: true,
      //   resourceName: "新增WanjinyouBill",
      //   routerUrl: "/PersonBillForm",
      //   resourceIcon: "",
      //   type: "2",
      //   buttons: [],
      //   component: loadable(() => import("./PersonBillForm")),
      // },
      //$MORE$
    ],
  },
  {
    needLogin: true,
    resourceName: i18n.t('PersonBill-index-1992f2b86c05c884e-3'),
    routerUrl: '/PersonBackBillApplyList',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./PersonBackBillApplyList')),
    children: [
      // {
      //   needLogin: true,
      //   resourceName: "新增WanjinyouBill",
      //   routerUrl: "/PersonBillForm",
      //   resourceIcon: "",
      //   type: "2",
      //   buttons: [],
      //   component: loadable(() => import("./PersonBillForm")),
      // },
      //$MORE$
    ],
  },
];
